module.exports = __webpack_public_path__ + "static/media/hand_front.568de9d0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/hand_front.svg
// module id = 472
// module chunks = 0